const link = process.env.REACT_APP_SERVER_API_V2

const getUsersUrl = () => `${link}/user/list`

export default getUsersUrl
